import React, { Component } from 'react';
import { connect } from 'react-redux';

import { performRequest, setPage } from './actions.mjs';

class ArticleLoadMore extends Component {
    constructor(props) {
        super(props);
    }

    changePage(event) {
        event.preventDefault();
        if (!this.props.loading) {
            this.props.dispatch(setPage(this.props.page +1))
            this.props.dispatch(performRequest());
        }
    }

    render() {
        if(this.props.results.topicalsTotal > this.props.results.topicalHits.length) {
            return (

                <div className="container">
                    <div className="row">
                        <div className="col-12 p-y-md text-center">
                            <a href="#" className="btn cta cta--pink" onClick={(event) => this.changePage(event)}>{this.props.loadMore}<i className="la icon-la-arrow-down"></i></a>
                        </div>
                    </div>
                </div>

            );
        }
        return null;
    }
}
const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        page: state.page,
        loadMore: state.loadMore,
        results: state.results
    };
};


export default connect(mapStateToProps)(ArticleLoadMore);